// Layout.jsx
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import LoadExternalScripts from "./LoadExScripts";
import CookieConsent from "react-cookie-consent";
import React from "react";


function Layout() {
    return (
        <>
            <LoadExternalScripts/>
            <Navbar />
            <main>
                <Outlet/>
            </main>
            <Footer/>
            <CookieConsent
                location="bottom"
                buttonText="Хорошо"
                cookieName="myAwesomeCookieName2"
                expires={150}
            >
                Используя данный сайт, вы даете согласие на использование файлов cookie, помогающих нам сделать его удобнее для вас.
            </CookieConsent>
        </>
    );
}

export default Layout;
